// In mediaPlayer.js
import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef, useCallback } from 'react';
import ReactPlayer from 'react-player';
import { RoundSpinner } from '../Loader/loader';

const MediaPlayer = forwardRef(({ 
    isView,
    activeFeedData, 
    autoPlay = false,
    controls = true,
    width = '65%',
    height = 320
}, ref) => {
    const [mediaUrl, setMediaUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const playerRef = useRef(null);

    // Stop and cleanup function
    const stopAndCleanup = useCallback(() => {
        if (playerRef.current) {
            const player = playerRef.current.getInternalPlayer();
            if (player) {
                player.pause();
                player.currentTime = 0;
                // Additional cleanup if needed
                if (mediaUrl && mediaUrl.startsWith('blob:')) {
                    URL.revokeObjectURL(mediaUrl);
                }
            }
        }
    }, [mediaUrl]);

    // Expose stop method to parent
    useImperativeHandle(ref, () => ({
        stop: stopAndCleanup
    }));

    // Effect to handle isView changes
    useEffect(() => {
        if (isView === false) {
            stopAndCleanup();
        }
        return () => {
            // Cleanup on unmount
            stopAndCleanup();
        };
    }, [isView, stopAndCleanup]);
    useEffect(() => {
    let isMounted = true;
    
    const fetchMediaUrl = async () => {
      if (activeFeedData?.url?.includes('whiteboard')) {
        try {
            const mediaRes = await fetch(process.env.REACT_APP_API_KEY + activeFeedData.url.substring(1));
            const mediaBlob = await mediaRes.blob();
            const mediaUrl = URL.createObjectURL(mediaBlob);
          if (isMounted) {
            setMediaUrl(mediaUrl);
            setLoading(false);
          }
        } catch (err) {
          console.error('Error fetching media URL:', err);
          if (isMounted) {
            setError('Failed to load media');
            setLoading(false);
          }
        }
      }
    };

    fetchMediaUrl();

    // Cleanup function
    return () => {
      isMounted = false;
    };
    }, [activeFeedData?.url]);

  if (isView === false) {
    return null;
  }

  if (loading) {
    return <div><RoundSpinner /></div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (activeFeedData?.type === 'image') {
    return (
      <div style={{
        marginTop: '100px'
      }}>   
      <img 
        src={mediaUrl} 
        alt="" 
        width="90%" 
        height="auto"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = '/images/error-image.jpg';
        }} 
      />
      </div>
    );
  }

  return (
    <ReactPlayer
      url={mediaUrl}
      controls={controls}
      playing={autoPlay}
      width={width}
      height={height}
      onError={(e) => {
        console.error('Error playing media:', e);
        setError('Error playing media');
      }}
    />
  );
});

export default MediaPlayer;